var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTickCircleGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 1.6665C5.40768 1.6665 1.66602 5.40817 1.66602 9.99984C1.66602 14.5915 5.40768 18.3332 9.99935 18.3332C14.591 18.3332 18.3327 14.5915 18.3327 9.99984C18.3327 5.40817 14.591 1.6665 9.99935 1.6665ZM13.9827 8.08317L9.25768 12.8082C9.14102 12.9248 8.98268 12.9915 8.81602 12.9915C8.64935 12.9915 8.49102 12.9248 8.37435 12.8082L6.01602 10.4498C5.77435 10.2082 5.77435 9.80817 6.01602 9.5665C6.25768 9.32484 6.65768 9.32484 6.89935 9.5665L8.81602 11.4832L13.0993 7.19984C13.341 6.95817 13.741 6.95817 13.9827 7.19984C14.2243 7.4415 14.2243 7.83317 13.9827 8.08317Z",
    fill: "#28C269"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircleGreen);
export default __webpack_public_path__ + "static/media/tick-circle-green.4b4d4cb5389ff6451cb35d92475877c2.svg";
export { ForwardRef as ReactComponent };